import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../models/api/integrationTypesModel';
import {AppState} from '../../store/appState';
import {getCompanyUrl} from '../../store/data/company/companySelectors';
import {makeGetIsIntegrationAvailableOnPlan} from '../../store/data/integrations/integrationSelectors';
import {makeGetIsIntegrationTypeEnabled} from '../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppCard} from './settingsAppCard';

/*
 * Props.
 */

interface SettingsAppCardContainerProps {
  integrationType: IntegrationTypeModel;
}

/*
 * Selectors.
 */

function getIntegrationTypeId(_state: AppState, props: SettingsAppCardContainerProps) {
  return props.integrationType.id;
}

/*
 * Redux.
 */

export const mapStateToProps = makeMapStateToProps<SettingsAppCardContainerProps>()(() => ({
  companyUrl: getCompanyUrl,
  isIntegrationEnabled: makeGetIsIntegrationTypeEnabled(getIntegrationTypeId),
  isIntegrationAvailableOnPlan: makeGetIsIntegrationAvailableOnPlan(getIntegrationTypeId),
}));

export const SettingsAppCardContainer = connect(mapStateToProps)(SettingsAppCard);
